const pathObj = {
  trainingCertifications: "/v1/user/employee/training-certifications",
  getSubscriptionList: "/v1/user/subscriptions",
  companyExist: "/v1/user/check-company-exists",
  categoryList: "/v1/user/categories",
  getContent: "/v1/user/static-content",
  getAllPages: "/v1/user/static-content/pages",
  getConfigApi: "/v1/user/static-content/config",
  faqs: "/v1/user/static-content/faqs",
  getCountryList: "/v1/user/master-data",
   getStatesByCountry: '/v1/user/cities-states',
  verifyEmail: "/v1/user/company/verify-email",
  verifyOTP: "/v1/user/company/send-email-otp",
  resendOTP: "/v1/user/company/resend-otp",
  purchaseSubscription: "/v1/user/company/purchase-subscription",
  subCategoryList: "/v1/user/sub-categories",
  getBanner: "/v1/user/banners",
  getStatic: "/v1/user/static-content/static",
  employeeSignup: "/v1/user/employee",
  registerUser: "/v1/user/employee",
  sendOTP: "/v1/user/employee/send-otp",
  userLogin: "/v1/user/employee/login",
  getJobs: "/v1/user/employee/jobs",
  changePassword: "/v1/user/employee/change-password",
  uploadImage: "/v1/user/employee/update-profile-picture",
  uploadProfile: "/v1/user/employee/update-profile-info",
  viewProfile: "/v1/user/employee/profile",
  subCategoryListID: "/v1/user/employee/subCategoryByCategoryID",
  filterList: "/v1/user/employee/filters",
  forgotPassword: "/v1/user/employee/forgot-password",
  resetPassword: "/v1/user/employee/reset-password",
  cityListID: "/v1/user/employee/citiesByCountryID",
  applyJob: "/v1/user/employee/apply-job",
  applyJobList: "/v1/user/employee/appliedJobs",
  getSetting: "/v1/user/settings",
  submitForm: "/v1/user/employee/form-submit",
  formsList: "/v1/user/employee/submitted-forms",
  biometricPunch: "/v1/user/employee/biometric-punch",
  editForms: "/v1/user/employee/form-edit",
  applyLeave: "/v1/user/employee/apply-leave",
  leaveList: "/v1/user/employee/leave",
  withdrawList: "/v1/user/employee/withdraw-leave",
  formDetails: "/v1/user/employee/form-details",
  employeeDateList: "/v1/user/employee/employee-dates",
  employeeSlip: "/v1/user/employee/employee-slip",
  employeeDayPunch: "v1/user/employee/employee-day-punch",
  employeeLeave: "v1/user/employee/employee-leave-dashboard",
  employeeSalary: "v1/user/employee/employee-salary",
  purchaseTempSubscription: "/v1/user/company/temp-purchase-subscription",
  upgradeSubscription: "/v1/user/company/upgrade-subscription",
  assignTaskRequestList: "/v1/user/task/assigned-task-request",
  employeeTaskList: "/v1/user/task",
  ChangeTaskRequest: "/v1/user/task/change-status-task-request",
  getEmployeeList: "/v1/user/task/employee-list",
  collaborationRequest: "/v1/user/task/send-collaboration",
  timeLogs: "/v1/user/task/add-time-logs",
  getTimeLogList: "/v1/user/task/time-logs",
  employeeTaskNotification: "/v1/user/task/task-new-notification",
  logout: "/v1/user/employee/logout",
  contactUs: "/v1/user/addContactUs",
  getNotifications: "/v1/user/employee/listNotification",
  checkNotification: "/v1/user/employee/check-notification",
  readNotification: "/v1/user/employee/read-notification",
  getDepartmentList: "/v1/companyAdmin/department/list",
  manageJobList: "/v1/admin/jobs",
  jobApprove: "/v1/admin/jobs/job-approve",
  manageDelete: "/v1/admin/jobs/job-delete",

  getForms: "/v1/companyAdmin/forms",
  getFormsById:"/v1/companyAdmin/forms/formById",
  addForm: "/v1/companyAdmin/forms/add",
  updateForm:"/v1/companyAdmin/forms/update",
  deleteCustomField: (formId, fieldId) => `/v1/companyAdmin/forms/${formId}/field/${fieldId}`,
  editForm: "/v1/companyAdmin/forms/edit", 
  deleteForm: "/v1/companyAdmin/forms/delete",
  getSuggestedForms: "/v1/companyAdmin/suggested-forms",
  addSuggestedForm: "/v1/companyAdmin/suggested-forms/add",

  getEmployeeListTask: "/v1/hr/tasks/employee-list",
  getTimeZoneList: "/v1/hr/tasks/timezones",
  taskAdd: "/v1/hr/tasks/assign-task",
  allTaskSchedulingList: "/v1/hr/tasks/list",
  taskEdit: "/v1/hr/tasks/edit-task",
  taskDelete: "/v1/hr/tasks/delete-task",
  taskReassign: "/v1/hr/tasks/reassign-task",
  getTimeLogList: "/v1/hr/tasks/time-logs",
  cancelTask: "/v1/hr/tasks/cancel-task",

  getDepartmentList: "/v1/hr/jobRequests/department/list",
  requestList: "/v1/hr/jobRequests",
  ChangeStatusJob: "/v1/hr/jobRequests/status-change",
  ChangeInterviewStatusJob: "/v1/hr/jobRequests/interview-status-change",
  allForms: "/v1/user/list-forms",
  updateReply: "/v1/hr/jobRequests/status-change",

  // Shift & Scheduling
  getAllShifts: "/v1/user/shift/",
  createShift: "/v1/user/shift/",
  shiftDelete: "/v1/user/shift/",
  publishSchedule: "/v1/user/shift/publish",

  // Locations
  getLocations: "/v1/user/shift/location",
  createLocation: "/v1/user/shift/location",
  syncLocation: "/v1/user/shift/location/sync",
  syncAllLocations: "/v1/user/shift/location/sync-all",
  payrollStatus: "/v1/hr/payroll/status",
  // Shift Templates
  getShiftTemplates: "/v1/user/shift/template",
  createShiftTemplate: "/v1/user/shift/template",
  
  // Availability
  getAvailableEmployeesList: "/v1/user/shift/available-employees-list",

  // Open Shifts
  getOpenShifts: "/v1/user/shift/open",
  shiftUpdate: "/v1/user/shift",

  createLocation: "/v1/user/shift/location",
  updateLocation: "/v1/user/shift/location",
  deleteLocation: "/v1/user/shift/location",
  
  getSwapRequests: "/v1/user/shift/swap-requests",
  shiftSwapApprove: "/v1/user/shift",
  shiftSwapReject: "/v1/user/shift",

  updateShiftTemplate: "/v1/user/shift/template",
  deleteShiftTemplate: "/v1/user/shift/template",

  // Leave Policy & PTO
  leavePolicyList: "/v1/hr/leave-policy/policy",
  leavePolicyCreate: "/v1/hr/leave-policy/policy",
  leavePolicyUpdate: "/v1/hr/leave-policy/policy",
  leavePolicyDelete: "/v1/hr/leave-policy/policy",
  employeeLeaveBalances: "/v1/hr/leave-policy/employee-balances",
  singleEmployeeBalance: "/v1/hr/leave-policy/employee-balance",
  adjustLeaveBalance: "/v1/hr/leave-policy/adjust-balance",
  runAccrual: "/v1/hr/leave-policy/run-accrual",
  generateTimesheets: "/v1/hr/timesheet/generate",
  hrTimesheets: "/v1/hr/timesheet/submitted",
  approveTimesheet: "/v1/hr/timesheet",
  rejectTimesheet: "/v1/hr/timesheet",
  editTimesheet: "/v1/hr/timesheet",
  deleteTimesheet: "/v1/hr/timesheet",
  deleteAdjustment: "/v1/hr/timesheet",
  getShiftForTask:  "/v1/hr/tasks/shift/employees",

  // New config path
  getGoogleMapsKey: "/v1/config/google-maps-key",

  aiInterviewTemplate: '/v1/hr/ai-interview/template',
  aiInterviewTemplateList: '/v1/hr/ai-interview/template/list',
  startAIInterview: '/v1/hr/ai-interview/start',
  aiInterviewRegenerate: '/v1/hr/ai-interview/session',
  aiInterviewReport: '/v1/hr/ai-interview/report',
  interviewList: "/v1/hr/ai-interview/interview-list",
  sendInterviewSchedule: "/v1/hr/ai-interview/interview-schedule",
  ChangeInterviewStatus: "/v1/hr/ai-interview/change-interview-status",
  aiInterviewReset: "/v1/hr/ai-interview/reset",
  aiInterviewSessionByJobRequest: "/v1/hr/ai-interview/session-by-jobrequest",
  getZoomLink: "/v1/zoom/create-meeting",
  zoomInterviewReset: "/v1/hr/ai-interview/reset-zoom",
  getPartnerInquiries: "/v1/admin/partner-inquiry",
  // new for AI recruiting assistent
  employeeRecommendation: "/v1/hr/employee-recommendation",
  jobsForFilter: "/v1/hr/employee-recommendation/job-filter",
  selectCandidateForInterview: "/v1/hr/select-for-interview",
  bulkSelectForInterview: "/v1/hr/select-for-interview/bulk",
  aiAssistantSearch: "/v1/hr/ai-assistant/search",
  payrollAdminBase: "/v1/admin/payroll",

  
  // ─── Jobs & Requirements ──────────────────────────────────────────────
  // getJobs: "/v1/Admin/jobs",
  manageAdd: "/v1/companyAdmin/jobs",
  manageEdit: "/v1/companyAdmin/jobs",
  manageDelete: "/v1/companyAdmin/jobs",
  manageList: "/v1/companyAdmin/jobs",
  adminJobDelete: "/v1/admin/jobs/job-delete",
  getStateList: "/v1/admin/state/list-by-country",
  listWithoutPagination: "/v1/companyAdmin/jobs/list",
  jobsStatus: "/v1/companyAdmin/jobs/change-status",
  getCategoryList: "/v1/companyAdmin/jobs/list",
  generateAIContent: "/v1/companyAdmin/jobs/generate-ai-content",
  getBillingSummary: "/v1/companyAdmin/jobs/billing-summary",
  getJobBillingBreakdown: "/v1/companyAdmin/jobs/billing-breakdown",
};
export default pathObj;
